import { createContext, useContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useApi } from "@/lib/api";
import Layout from "@/components/Layout";
import NoAccess from "@/pages/NoAccess";

const MeContext = createContext(null);
export const useMe = () => useContext(MeContext);

export default function MeGate() {
  const api = useApi();
  const [me, setMe] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get("/me").then((r) => setMe(r.data)).catch(() => setError(true));
  }, [api]);

  if (error) return <NoAccess reason="error" />;
  if (!me)
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="me-loading">
        <Loader2 className="h-6 w-6 animate-spin text-orange-500" />
      </div>
    );
  if (me.role === "pending") return <NoAccess email={me.email} />;
  return (
    <MeContext.Provider value={me}>
      <Layout>
        <Outlet />
      </Layout>
    </MeContext.Provider>
  );
}
